import { useActiveOrganization } from "./organizations";
import { useUsageOperations } from "../queries/usage/useUsageOperations";

export function useUsageMetricsData() {
  const organization = useActiveOrganization();
  const { data: operations = [], isLoading, error } = useUsageOperations();

  return {
    operations,
    loading: isLoading,
    error,
    organizationId: organization?.id,
  };
}
